import React from "react";
import { ClickButton } from "../../../base/buttons";
import { translate } from "../../../base/i18n";
import ConferenceTimer from "../../../conference/components/ConferenceTimer";

function GroupCard({
    t, item, setPopup, currentGroupId, handlerChangeConference, handlerChangeGroupStatus
}) {
    const belong =  item.belong > 0 ? true : false;
    return (
        <div className="group_item" >
            <div className="layout_name" style={{ borderBottom: "2px solid"}}>{item.name} </div>
            <div className="item_body">
                <div className="table">
                    <ul>
                        <li>{t("group.time")}</li>
                        <li>{item.status === "opened" ? <ConferenceTimer currentGroupId={item.uuid} /> : "closed"}</li>
                    </ul>
                    <ul>
                        <li>{t("group.allCount")}</li>
                        <li>{ t("common.person", { count: item.all }) }</li>
                    </ul>
                    <ul style={{ borderBottom: "none"}}>
                        <li>{t("group.attendCount")}</li>
                        <li>{ t("common.person", { count: item.belong }) }</li>
                    </ul>
                </div>
                <div className={`${belong ? 'button_right' : 'button_center'}`}>
                    { item.status === "opened" && <>
                        <ClickButton text={item.uuid === currentGroupId ? t("group.out"): t("group.enter")} size={16} onClick={() => handlerChangeConference(item.uuid)} />
                        { belong && <ClickButton text={t("group.sendMessage")} size={16} onClick={() => setPopup(item.uuid) } /> }
                    </> }
                </div>
                <ClickButton text={ item.status === "opened" ? t("group.end") : t("group.start") } size={16} onClick={() => handlerChangeGroupStatus(item.uuid, item.status)}  />
            </div>            
        </div>
    )
}
export default translate(GroupCard);